import { render, staticRenderFns } from "./chainInoutOrder.vue?vue&type=template&id=aaa5d3fe&scoped=true"
import script from "./chainInoutOrder.vue?vue&type=script&lang=js"
export * from "./chainInoutOrder.vue?vue&type=script&lang=js"
import style0 from "./chainInoutOrder.vue?vue&type=style&index=0&id=aaa5d3fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa5d3fe",
  null
  
)

export default component.exports